module.exports = __webpack_public_path__ + "img/team-02.dcf0186f.jpg";